import React, { memo } from 'react';
import Input from '../input';

const dateInputWrapper = 'date-input-wrapper';
const dateDisplayWrapper = 'date-display-wrapper';

const DisplayTimeFnCollection = new Map([
  ['month', ({
    year,
    month,
  }) => {
    if (isNaN(year)) {
      return '';
    }

    if (isNaN(month)) {
      return '';
    }

    const _dT = `${month}/${year}`;

    return _dT;
  }],
  ['date', ({
    year,
    month,
    date,
    time,
  }) => {
    if (isNaN(year)) {
      return '';
    }

    if (isNaN(month)) {
      return '';
    }

    if (isNaN(date)) {
      return '';
    }

    let _dT = `${month}/${date}/${year}`;

    if (time) _dT += ` at ${time}`;

    return _dT;
  }]
]);

export const DateWrapper = memo(({
  name,
  value,
  max,
  label = 'DATE:',
  type = 'date',
  disabled = false,
  readOnly = false,
  inputClassName = '',
  onChange: handleChange = () => {}
}) => {
  const [year, month, date, time] = (() => {
    try {
      if (typeof(value) !== 'string') {
        return ['-', '-', '-', '-'];
      }

      if (value.length === 0) {
        return ['-', '-', '-', '-'];
      }

      const [_date, _time] = value.split('T');
      return [..._date.split('-'), _time];
    } catch(e) {
      return ['-', '-', '-', '-'];
    }
  })();

  const DTFn = DisplayTimeFnCollection.get(type) || DisplayTimeFnCollection.get('date');
  const displayTime = DTFn({ year, month, date, time });

  return (
    <>
      <div className={`flex align-items-center ${dateInputWrapper}`}>
        <Input
          name={name}
          label={label}
          type={type}
          value={value}
          max={max}
          disabled={disabled}
          readOnly={readOnly}
          inputClassName={inputClassName}
          onChange={handleChange}
        />
      </div>
      <div className={`flex align-items-center ${dateDisplayWrapper} d-none`}>
        {
          label && <label className='input-label m-r-4'>{label}</label>
        }
        <span className={`input-display-wrapper font-14 tracking-widest flex align-items-center min-width-140 ${inputClassName}`}>{displayTime}</span>
      </div>
    </>
  );
});

export default DateWrapper;
